var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { Container, Pointer, Root, TextContent, DismissIcon, IconContainer, } from './styledComponents';
import { DISMISS_ICON_TITLE } from '../constants';
const StyledTooltip = (_a) => {
    var props = __rest(_a, []);
    const { textContent, pointer, isDismissable, dismissClick, } = props;
    const [isVisible, setIsVisible] = useState(true);
    const handleDismiss = () => {
        if (dismissClick && typeof dismissClick === 'function') {
            dismissClick();
        }
        else {
            setIsVisible(false);
        }
    };
    if (!textContent || !isVisible) {
        return null;
    }
    return (React.createElement(Root, Object.assign({}, props),
        pointer && React.createElement(Pointer, Object.assign({}, props)),
        React.createElement(Container, null,
            React.createElement(TextContent, null, textContent),
            isDismissable && (React.createElement(IconContainer, { onClick: handleDismiss },
                React.createElement(DismissIcon, { size: "20px", title: DISMISS_ICON_TITLE }))))));
};
export default StyledTooltip;
